<template>
  <div class="not-found-container">
    <div class="not-found-content flex flex-col items-center justify-center">
      <!-- 404图标 -->
      <div class="not-found-icon w-202px ">
        <img src="@/assets/images/other/404.webp" alt="404" />
      </div>

      <!-- 错误信息 -->
      <div class="not-found-text">
        <h1 class="title font-900 text-16px">{{ t('notFound.title') }}</h1>
        <p class="description text-12px color-#fff font-500">{{ t('notFound.description') }}</p>
      </div>

      <!-- 操作按钮 -->
      <div class="not-found-actions">
        <van-button type="primary" size="large" @click="goHome" class="action-btn">
          {{ t('notFound.goHome') }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useLoginDialog } from '@/composables/useLoginDialog'

const router = useRouter()
const { t } = useI18n()
const { show: showLogin } = useLoginDialog()

// 返回首页
const goHome = () => {
  router.push({ name: 'Home' })
}

// 临时：提供一个全局登录弹窗的触发方法，方便验收
// 可在页面控制台执行：window.__showLogin()
;(window as any).__showLogin = async () => {
  await showLogin()
}

// 返回上一页
const goBack = () => {
  if (window.history.length > 1) {
    router.go(-1)
  } else {
    router.push({ name: 'Home' })
  }
}
</script>

<style lang="scss" scoped>
.not-found-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #01031B;
  padding: 20px;
}

.not-found-content {
  text-align: center;
  max-width: 400px;
  width: 100%;
}

.not-found-icon {
  margin-bottom: 30px;

  .icon-404 {
    font-size: 120px;
    font-weight: 900;
    color: rgba(255, 255, 255, 0.1);
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
    line-height: 1;
  }
}

.not-found-text {
  margin-bottom: 40px;

  .title {
    // text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    color: #fff;
    margin-bottom: 10px;
  }

  .description {
    font-size: 16px;
    // color: rgba(255, 255, 255, 0.8);
    margin: 0;
    line-height: 1.5;
  }
}

.not-found-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .action-btn {
    width: 100%;
    height: 48px;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    width: 210px;
    height: 36px;
  }
}

// 响应式设计
@media (max-width: 480px) {
  .not-found-container {
    padding: 16px;
  }

  .not-found-icon .icon-404 {
    font-size: 100px;
  }

  .not-found-text .title {
    font-size: 24px;
  }

  .not-found-text .description {
    font-size: 14px;
  }
}
</style>
